import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useParams } from 'react-router';
import QueryRenderer from '../../../../../shared/relay/QueryRenderer';
import DeliverableReferencesList from './DeliverableReferencesList';
import { PAGINATION_TYPES } from '../../../../../shared/constants';
import {
  withTableHistoryProvider,
  useTableHistoryQueryVariables
} from '../../../../../shared/contexts/tableHistoryContext';

const DeliverableReferenceTab = ({ tableName, ...otherProps }) => {
  const variables = useTableHistoryQueryVariables();
  const { id } = useParams();

  return (
    <QueryRenderer
      query={graphql`
        query DeliverableReferenceTabQuery(
          $id: ID!
          $first: Int
          $after: String
          $orderBy: String
        ) {
          deliverable(id: $id) {
            ...DeliverableReferencesList_deliverable
          }
        }
      `}
      variables={{ id, ...variables }}
      render={relayProps => (
        <DeliverableReferencesList deliverable={relayProps.deliverable} {...otherProps} />
      )}
    />
  );
};

export default withTableHistoryProvider(DeliverableReferenceTab, 'orgDelReference', {
  rowsPerPage: PAGINATION_TYPES.short.defaultValue,
  after: null,
  orderBy: '-created'
});
